<div *ngIf="loading.value" class="d-flex justify-content-center py-4">
    <mat-spinner></mat-spinner>
</div>
<div *ngIf="!loading.value" class="p-3">
    <table class="role-table">
        <thead>
            <tr>
                <th class="col-index">#</th>
                <th class="col-name">Name</th>
                <th class="col-action">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr class="role-row" *ngFor="let role of roles; let i = index" [formGroup]="roleForms[i]">
                <td class="col-index">{{ i + 1 }}</td>
                <td class="col-name">
                    <a *ngIf="editingIndex !== i" class="role-link" [routerLink]="['/permissions/roles', role.id]">{{ role.name }}</a>
                    <mat-form-field *ngIf="editingIndex === i" appearance="outline" class="role-name-field" hideRequiredMarker>
                        <mat-label>Role Name <span class="red">*</span></mat-label>
                        <input matInput formControlName="name">
                    </mat-form-field>
                </td>
                <td class="col-action">
                    <div class="action-buttons">
                        <button *ngIf="editingIndex !== i" mat-raised-button class="action-button" (click)="onEditClick(i)">
                            <mat-icon>edit</mat-icon>
                            Update
                        </button>
                        <button *ngIf="editingIndex === i" mat-raised-button class="action-button"
                            [disabled]="roleForms[i].invalid || savingRoleId === role.id"
                            (click)="onSubmitClick(i)">
                            <mat-icon>save</mat-icon>
                            Submit
                        </button>
                        <button *ngIf="editingIndex === i" mat-raised-button class="cancel-button"
                            [disabled]="savingRoleId === role.id"
                            (click)="onCancelClick(i)">
                            Cancel
                        </button>
                        <button *ngIf="editingIndex !== i" mat-raised-button class="warn-button"
                            [disabled]="deletingRoleId === role.id"
                            (click)="onDeleteClick(i)">
                            <mat-icon>delete</mat-icon>
                            Delete
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
